module.exports = __webpack_public_path__ + "img/coaching.4fc880a3.svg";